import { Component, OnInit, inject } from '@angular/core';
import { FormService } from '../../services/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderComponent } from '@rbb/ng-web-template-lib';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css'],
  imports: [LoaderComponent]
})
export class TagComponent implements OnInit {
  private formService = inject(FormService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  loading = true;
  tag: string | undefined;

  ngOnInit(): void {
    this.tag = this.route.snapshot.params['tag'];
    this.getFormIdByTag();
  }

  getFormIdByTag(): void {
    if (this.tag) {
      this.formService.getFormIdByTag(this.tag).subscribe({
        next: (next) => {
          this.router.navigate(['form', next.value], { replaceUrl: true, queryParamsHandling: 'preserve' }).then();
        },
        error: () => {
          this.loading = false;
        }
      });
    }
  }
}
